var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExpLeadership(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_269_5945)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.9993 26.5833C23.0119 26.5833 23.8327 25.7625 23.8327 24.75C23.8327 23.7374 23.0119 22.9166 21.9993 22.9166C20.9868 22.9166 20.166 23.7374 20.166 24.75C20.166 25.7625 20.9868 26.5833 21.9993 26.5833Z",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.5573 17.6587L24.0982 19.4334C24.1874 19.7282 24.3853 19.9781 24.6518 20.1326C24.9183 20.2871 25.2334 20.3347 25.5337 20.2657L27.3322 19.8477C27.6732 19.7711 28.0297 19.8057 28.3497 19.9463C28.6696 20.0869 28.9362 20.3263 29.1103 20.6293C29.2845 20.9323 29.3571 21.2831 29.3175 21.6304C29.278 21.9776 29.1283 22.3031 28.8905 22.5592L27.631 23.9177C27.4216 24.1443 27.3053 24.4415 27.3053 24.75C27.3053 25.0586 27.4216 25.3557 27.631 25.5824L28.8905 26.9409C29.1283 27.1969 29.278 27.5224 29.3175 27.8697C29.3571 28.2169 29.2845 28.5677 29.1103 28.8707C28.9362 29.1738 28.6696 29.4131 28.3497 29.5537C28.0297 29.6944 27.6732 29.7289 27.3322 29.6524L25.5337 29.2344C25.2334 29.1654 24.9183 29.213 24.6518 29.3675C24.3853 29.522 24.1874 29.7719 24.0982 30.0667L23.5573 31.8414C23.4583 32.1779 23.253 32.4734 22.9721 32.6836C22.6912 32.8938 22.3498 33.0074 21.999 33.0074C21.6482 33.0074 21.3067 32.8938 21.0258 32.6836C20.7449 32.4734 20.5396 32.1779 20.4407 31.8414L19.8998 30.0667C19.8105 29.7719 19.6127 29.522 19.3462 29.3675C19.0797 29.213 18.7645 29.1654 18.4643 29.2344L16.6658 29.6524C16.3248 29.7289 15.9682 29.6944 15.6483 29.5537C15.3283 29.4131 15.0618 29.1738 14.8876 28.8707C14.7135 28.5677 14.6409 28.2169 14.6804 27.8697C14.72 27.5224 14.8696 27.1969 15.1075 26.9409L16.367 25.5824C16.5764 25.3557 16.6926 25.0586 16.6926 24.75C16.6926 24.4415 16.5764 24.1443 16.367 23.9177L15.1075 22.5592C14.8696 22.3031 14.72 21.9776 14.6804 21.6304C14.6409 21.2831 14.7135 20.9323 14.8876 20.6293C15.0618 20.3263 15.3283 20.0869 15.6483 19.9463C15.9682 19.8057 16.3248 19.7711 16.6658 19.8477L18.4643 20.2657C18.7645 20.3347 19.0797 20.2871 19.3462 20.1326C19.6127 19.9781 19.8105 19.7282 19.8998 19.4334L20.4407 17.6587C20.5396 17.3221 20.7449 17.0266 21.0258 16.8164C21.3067 16.6063 21.6482 16.4927 21.999 16.4927C22.3498 16.4927 22.6912 16.6063 22.9721 16.8164C23.253 17.0266 23.4583 17.3221 23.5573 17.6587Z",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.9993 7.33329C23.7713 7.33329 25.2077 5.89687 25.2077 4.12496C25.2077 2.35305 23.7713 0.916626 21.9993 0.916626C20.2274 0.916626 18.791 2.35305 18.791 4.12496C18.791 5.89687 20.2274 7.33329 21.9993 7.33329Z",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.4173 13.75C28.0537 12.3242 27.2256 11.0601 26.0636 10.1572C24.9017 9.25439 23.4721 8.76428 22.0007 8.76428C20.5292 8.76428 19.0996 9.25439 17.9377 10.1572C16.7757 11.0601 15.9476 12.3242 15.584 13.75",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.6673 36.6667C38.4392 36.6667 39.8757 35.2302 39.8757 33.4583C39.8757 31.6864 38.4392 30.25 36.6673 30.25C34.8954 30.25 33.459 31.6864 33.459 33.4583C33.459 35.2302 34.8954 36.6667 36.6673 36.6667Z",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.0833 43.0833C42.7197 41.6574 41.8916 40.3933 40.7297 39.4905C39.5677 38.5876 38.1381 38.0975 36.6667 38.0975C35.1952 38.0975 33.7656 38.5876 32.6037 39.4905C31.4417 40.3933 30.6136 41.6574 30.25 43.0833",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.33333 36.6667C9.10525 36.6667 10.5417 35.2302 10.5417 33.4583C10.5417 31.6864 9.10525 30.25 7.33333 30.25C5.56142 30.25 4.125 31.6864 4.125 33.4583C4.125 35.2302 5.56142 36.6667 7.33333 36.6667Z",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.7493 43.0833C13.3858 41.6574 12.5576 40.3933 11.3957 39.4905C10.2337 38.5876 8.80416 38.0975 7.33268 38.0975C5.86121 38.0975 4.43165 38.5876 3.2697 39.4905C2.10775 40.3933 1.2796 41.6574 0.916016 43.0833",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.5915 38.5C23.9639 39.7218 20.0359 39.7218 16.4082 38.5",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.7871 6.41663C33.0999 8.07651 35.798 10.7483 37.4904 14.0446C39.1827 17.3409 39.7813 21.0906 39.1994 24.75",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.80032 24.75C4.21847 21.0901 4.8175 17.3401 6.51056 14.0436C8.20361 10.7472 10.9027 8.07573 14.2163 6.41663",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_269_5945"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 44,
    height: 44,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExpLeadership);
export default __webpack_public_path__ + "static/media/exp_leadership.4379804f97a6f3649af3610f3d1f3444.svg";
export { ForwardRef as ReactComponent };